import script from "./JsonRawViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./JsonRawViewer.vue?vue&type=script&setup=true&lang=js"

import "./JsonRawViewer.vue?vue&type=style&index=0&id=189bdb26&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-189bdb26"]])

export default __exports__